import axios from "@/utils/axios";
import { ref } from "vue";
export default () => {
    const data = ref(null);
    const loading = ref(false);
    const error = ref(null);
    const success = ref(false);
    const fetch = async (config) => {
        loading.value = true;
        await axios
            .request(config)
            .then((response) => {
            data.value = response.data;
            success.value = true;
        })
            .catch((err) => {
            error.value = err.response?.data;
        })
            .finally(() => {
            loading.value = false;
        });
    };
    return {
        fetch,
        data,
        loading,
        error,
        success,
    };
};
